<template>
  <div class="clients-crud">
    <h1>Gestión de Clientes</h1>
    <form @submit.prevent="saveClient">
      <input type="hidden" v-model="client.id">
      <input type="text" v-model="client.nombre" placeholder="Nombre del Cliente" required>
      <input type="text" v-model="client.telefono" placeholder="Teléfono">
      <textarea v-model="client.historial" placeholder="Historial (JSON)"></textarea>
      <button type="submit">Guardar</button>
      <button type="button" @click="clearForm" v-if="client.id">Cancelar Edición</button>
    </form>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Nombre</th>
          <th>Teléfono</th>
          <th>Historial</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cli in clients" :key="cli.id">
          <td>{{ cli.id }}</td>
          <td>{{ cli.nombre }}</td>
          <td>{{ cli.telefono }}</td>
          <td>{{ cli.historial }}</td>
          <td>
            <button @click="editClient(cli)">Editar</button>
            <button @click="deleteClient(cli.id)">Eliminar</button>
            <button @click="viewAttentions(cli)">Ver Atenciones</button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="showAttentionsModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showAttentionsModal = false">&times;</span>
        <h2>Atenciones de {{ selectedClient.nombre }}</h2>
        <div v-if="selectedClientAttentions.length > 0">
          <div v-for="attention in selectedClientAttentions" :key="attention.id" class="attention-card">
            <p><strong>Fecha:</strong> {{ new Date(attention.fecha).toLocaleDateString() }}</p>
            <p><strong>Manicurista:</strong> {{ attention.manicurista_nombre }}</p>
            <p><strong>Monto:</strong> ${{ attention.monto }}</p>
            <p><strong>Observaciones:</strong> {{ attention.observaciones }}</p>
            <p><strong>Productos:</strong>
              <span v-if="attention.productos && attention.productos.length > 0">
                {{ attention.productos.map(p => p.nombre).join(', ') }}
              </span>
              <span v-else>N/A</span>
            </p>
            <img v-if="attention.foto_path" :src="attention.foto_path" alt="Foto de Atención" class="attention-photo">
          </div>
        </div>
        <p v-else>No hay atenciones registradas para este cliente.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ClientsCRUD',
  data() {
    return {
      client: {
        id: null,
        nombre: '',
        telefono: '',
        historial: '{}',
      },
      clients: [],
      showAttentionsModal: false,
      selectedClient: null,
      selectedClientAttentions: [],
    };
  },
  created() {
    this.fetchClients();
  },
  methods: {
    async fetchClients() {
      try {
        const response = await axios.get('/api/clients'); 
        this.clients = response.data;
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    },
    async viewAttentions(client) {
      this.selectedClient = { ...client };
      this.showAttentionsModal = true;
      try {
        const response = await axios.get('/api/atenciones');
        // Filter attentions by client name (case-insensitive)
        this.selectedClientAttentions = response.data.filter(
          (attention) => attention.cliente_nombre.toLowerCase() === client.nombre.toLowerCase()
        );
      } catch (error) {
        console.error('Error fetching attentions:', error);
        this.selectedClientAttentions = [];
      }
    },
    async saveClient() {
      try {
        if (this.client.id) {
          await axios.put(`/api/clients/${this.client.id}`, this.client);
        } else {
          await axios.post('/api/clients', this.client);
        }
        this.clearForm();
        this.fetchClients();
      } catch (error) {
        console.error('Error saving client:', error);
      }
    },
    editClient(client) {
      this.client = { ...client };
    },
    async deleteClient(id) {
      if (confirm('¿Estás seguro de que quieres eliminar este cliente?')) {
        try {
          await axios.delete(`/api/clients/${id}`);
          this.fetchClients();
        } catch (error) {
          console.error('Error deleting client:', error);
        }
      }
    },
    clearForm() {
      this.client = {
        id: null,
        nombre: '',
        telefono: '',
        historial: '{}',
      };
    },
  },
};
</script>

<style scoped>
.clients-crud {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

input, textarea, button {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

button {
  background-color: #42b983;
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #369f75;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}
</style>

<style scoped>
/* Modal Styles */
.modal {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  max-width: 700px;
  border-radius: 8px;
  position: relative;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 20px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

/* Attention Card Styles */
.attention-card {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #f9f9f9;
}

.attention-card p {
  margin-bottom: 5px;
}

.attention-photo {
  max-width: 100%;
  height: auto;
  display: block;
  margin-top: 10px;
  border-radius: 4px;
}
</style>
